import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Public marketing routes that should remain indexable by search engines.
const INDEXABLE = new Set([
  "/",
  "/gp-practices",
  "/psychologists",
  "/psychiatrists",
  "/pricing",
  "/privacy",
  "/terms",
  "/contact",
]);

// Centralised robots meta control for the SPA. Public marketing pages stay
// "index, follow"; every other route (auth, signup, dashboards, portals,
// onboarding, admin) becomes "noindex, follow". Content/SEO only — does not
// touch any app functionality.
export default function RobotsMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalised = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    let content;
    if (normalised.startsWith("/admin") || normalised.startsWith("/sample-") || normalised.startsWith("/demo/access/")) {
      content = "noindex, nofollow";
    } else {
      content = INDEXABLE.has(normalised) ? "index, follow" : "noindex, follow";
    }

    let el = document.head.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  }, [pathname]);

  return null;
}
